export default __webpack_public_path__ + "static/media/icon_centro_custos_ai.9514a1ab.svg";